import { render, staticRenderFns } from "./ClientTab.vue?vue&type=template&id=657bf800&"
import script from "./ClientTab.vue?vue&type=script&lang=js&"
export * from "./ClientTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports